import { useRef } from "react";
import { useAppSelector } from "store/hooks";
import { useModal } from "utils/hooks/useModal";
import { usePagination } from "utils/hooks/usePagination";
import { useSocialIntent } from "./model/useSocialIntent";
import { bodyContainer } from "../Pulse/style";

import Container from "components/atoms/layout/Container/Container";
import { Filter } from "components/atoms/Filter";
import { SocialItentHeader } from "components/layouts/socialIntentHeader";
import { ManageKeywords } from "components/molecules/ManageKeywords";
import Popup from "components/molecules/Popup/Popup";
import { SocialList } from "components/molecules/SocialList";
import { Footer } from "components/molecules/TableFooter";

export const SocialIntentModule = () => {
  const { isOpen, openModal, closeModal } = useModal();
  const { page, limit } = usePagination({ totalItems: 0 });
  const {
    data,
    keywords,
    totalItems,
    isLoadingContent,
    isLoadingKeywords,
    isLastPage,
    isScraping,
    filetrsApplyed,
    addNewKeywords,
    deleteKeyword,
    handleStartScrap,
  } = useSocialIntent({ page, limit });
  const ref = useRef(null) as any;
  const { ui } = useAppSelector((state) => state);

  const { footer } = bodyContainer({
    isExport: ui.exportOpen,
    sidebarOpen: ui.filterOpen,
  });

  const optionsKeyswords = keywords.map((keyword) => {
    return {
      label: keyword.keyword,
      value: keyword.keyword,
    };
  });

  return (
    <Container
      direction="row"
      className="flex flex-1 gap-5 py-4 px-5 flex-row  overflow-hidden"
    >
      <div
        className={`flex flex-1 gap-5 overflow-hidden ${
          ui.filterOpen ? "flex-row" : "flex-col"
        }`}
      >
        <div
          className={`flex flex-row justify-between h-fit items-center ${
            ui.filterOpen ? "w-fit" : "w-full"
          }`}
        >
          {keywords.length > 0 && (
            <Filter
              filters={[
                {
                  icon: "search",
                  label: "Keywords",
                  name: "keywords",
                  placeholder: "Search by keywords",
                  type: "selectable",
                  options: optionsKeyswords,
                },
              ]}
            />
          )}
          {!ui.filterOpen && <SocialItentHeader handleOpen={openModal} />}
        </div>

        <div className="!bg-gray-800 rounded-xl border border-gray-700 overflow-hidden w-full">
          {isOpen && (
            <Popup type="modal" width="sm" onClose={closeModal}>
              <ManageKeywords
                isLoading={isLoadingKeywords}
                keywords={keywords}
                handleAddKeyword={addNewKeywords}
                handleRemoveKeyword={deleteKeyword}
                handleScrapData={handleStartScrap}
              />
            </Popup>
          )}
          <SocialList
            externalRef={ref}
            data={data}
            isLoading={isLoadingContent}
            isEmptyKeyword={!keywords.length}
            isScraping={isScraping}
            filetrsApplyed={filetrsApplyed}
          />

          {data.length > 0 && (
            <div className={footer()}>
              <Footer
                totalItems={totalItems < limit ? limit : totalItems}
                className="border-t border-gray-700 rounded-b-2xl"
              />
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};
